import { render, staticRenderFns } from "./CreateCampaignButton.vue?vue&type=template&id=f5da95e0&scoped=true"
import script from "./CreateCampaignButton.vue?vue&type=script&lang=js"
export * from "./CreateCampaignButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5da95e0",
  null
  
)

export default component.exports